import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

/**
 * Submit a lead (contact or work-from-home application).
 * Modular by design: the backend stores submissions and can later be wired to
 * WhatsApp / email / CRM without changing this frontend contract.
 *
 * @param {"contact"|"applications"} endpoint
 * @param {Object} fields  key/value form fields
 * @param {File|null} resume  optional resume file
 */
export async function submitLead(endpoint, fields, resume) {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, value);
    }
  });
  if (resume) {
    formData.append("resume", resume);
  }
  const { data } = await client.post(`/${endpoint}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
